import React from "react";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";

export default class Menu extends SeoComponent {
    render() {
        this.setMetaTags('Stations page', 'Default description');

        return <LayoutComponent routerMatch={this.props.match}>
            Menu
        </LayoutComponent>;
    }
}


// WEBPACK FOOTER //
// ./src/js/components/Menu.js